"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiResponse } from "@/shared/types/interface/api";
import type { HealthInfoListItem, HealthInfoListResponse } from "@/entities/health-info/model/types";
import { useInfiniteQueryHospitalHealthInfoList } from "@/entities/health-info/hooks/queries";
import HealthInfoCard from "@/widgets/health-info/ui/HealthInfoCard";
type Props = {
  hospitalOriginId: number;
  locale: string;
  initialResponse: ApiResponse<HealthInfoListResponse>;
};
export default function HospitalHealthInfoList(t0) {
  const $ = _c(27);
  const {
    hospitalOriginId,
    locale,
    initialResponse
  } = t0;
  let t1;
  if ($[0] !== hospitalOriginId) {
    t1 = Number.isSafeInteger(hospitalOriginId) && hospitalOriginId > 0;
    $[0] = hospitalOriginId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const validHospitalId = t1;
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetchNextPageError
  } = useInfiniteQueryHospitalHealthInfoList(hospitalOriginId, initialResponse, locale === "ko" && validHospitalId && initialResponse.result.total > 0);
  if (locale !== "ko" || !validHospitalId || initialResponse.result.total <= 0) {
    return null;
  }
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[2] !== data?.pages || $[3] !== hospitalOriginId || $[4] !== initialResponse) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const uniqueItems = new Map();
      for (const page of data?.pages ?? [initialResponse]) {
        for (const item of page.result.contents) {
          if (item.hospitalOriginId === hospitalOriginId && !uniqueItems.has(item.id)) {
            uniqueItems.set(item.id, item);
          }
        }
      }
      if (uniqueItems.size === 0) {
        t5 = null;
        break bb0;
      }
      t3 = "divide-y divide-gray-100";
      t4 = "\uAD00\uB828 \uAC74\uAC15\uC815\uBCF4";
      t2 = [...uniqueItems.values()];
    }
    $[2] = data?.pages;
    $[3] = hospitalOriginId;
    $[4] = initialResponse;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[9] !== locale || $[10] !== t2) {
    t6 = t2.map(item_0 => <li key={item_0.id}><HealthInfoCard item={item_0} locale={locale} /></li>);
    $[9] = locale;
    $[10] = t2;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t6) {
    t7 = <ul className={t3} aria-label={t4}>{t6}</ul>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== isFetchNextPageError) {
    t8 = isFetchNextPageError && <p role="alert" className="mt-3 text-sm text-gray-600">건강정보를 더 불러오지 못했습니다.</p>;
    $[16] = isFetchNextPageError;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== fetchNextPage || $[19] !== hasNextPage || $[20] !== isFetchNextPageError || $[21] !== isFetchingNextPage) {
    t9 = hasNextPage && <button type="button" disabled={isFetchingNextPage} onClick={() => {
      fetchNextPage();
    }} className="mt-4 w-full rounded-lg border border-gray-200 px-4 py-3 text-sm font-medium text-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-600 disabled:opacity-50">{isFetchingNextPage ? "\uBD88\uB7EC\uC624\uB294 \uC911" : isFetchNextPageError ? "\uB2E4\uC2DC \uC2DC\uB3C4" : "\uB354 \uBCF4\uAE30"}</button>;
    $[18] = fetchNextPage;
    $[19] = hasNextPage;
    $[20] = isFetchNextPageError;
    $[21] = isFetchingNextPage;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t10 = <>{t7}{t8}{t9}</>;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}